import { colorClasses } from "../constants/color";
import { TextComponent } from "./TextComponent";

interface LabelButtonProps {
	items: string[];
	setItems?: React.Dispatch<React.SetStateAction<string[]>>;
	color?: "red" | "blue" | "green" | "roseWhite" | "purple" | "violet" | "mutedViolet" | "gray";
	secondary?: boolean;
	limit?: number;
	pointerEvents?: boolean;
	x?: boolean;
}

export const Label: React.FC<LabelButtonProps> = ({ items, color = "default", secondary = false, limit = 999, pointerEvents = false, x = false, setItems }) => {
	const themeColor = colorClasses[secondary ? "secondary" : "primary"][color] || colorClasses[secondary ? "secondary" : "primary"].default;
	const handleRemoveItem = (itemToRemove: string) => {
		if (!setItems) return;
		setItems((prevItems) => prevItems.filter((item) => item !== itemToRemove));
	};
	return (
		<>
			{items.slice(0, limit).map((item, index) => (
				<span
					key={index}
					className={`flex gap-1 items-center justify-center  px-4 py-2 rounded select-none transition-colors duration-300 ease-in-out ${themeColor} ${
						pointerEvents && "pointer-events-none"
					}`}
				>
					<TextComponent variant="h5">{item}</TextComponent>
					{x && (
						<button
							className="cursor-pointer hover:text-gray-800 text-gray-600"
							onClick={() => handleRemoveItem(item)}
							tabIndex={-1}
						>
							✕
						</button>
					)}
				</span>
			))}
		</>
	);
};
